<template>
  <div>
    <nav class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'organizations'}">Organizations</router-link>
            <span class="mx-2">/</span>
            <span>{{ organization.name }}</span>
          </div>
          <div class="text-xl text-primary">
            Access control
          </div>
        </div>
        <div class=""></div>
      </div>
    </nav>
    <div class="md:flex block">
      <div class="w-full rounded-lg  overflow-hidden  md:max-w-xs mb-3">
        <div class=" bg-white rounded-lg border shadow-sm">
          <img :src="require('@/assets/img/access_control.jpg')"
               class="w-full hidden md:block"/>

          <ul class="mt-2 flex flex-wrap md:block">
            <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
              <router-link :to="{name: 'access_control', params: { path: 'administrators'}}"
                           class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                <feather type="users" size="16" class="mr-4"></feather>
                Administrators
              </router-link>
            </li>
            <li class="border-l-4 border-transparent hover:border-teal-700 my-2 "
                v-if="$store.getters.can('create_administrators')">
              <router-link :to="{name: 'access_control', params: { path: 'invite_administrators'}}"
                           class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                <feather type="user-plus" size="16" class="mr-4"></feather>
                Invite administrators
              </router-link>
            </li>
            <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
              <router-link :to="{name: 'access_control', params: { path: 'roles'}}"
                           class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                <feather type="sliders" size="16" class="mr-4"></feather>
                Roles
              </router-link>
            </li>
            <li class="border-l-4 border-transparent hover:border-teal-700 my-2 "
                v-if="$store.getters.can('create_administrators')">
              <router-link :to="{name: 'access_control', params: { path: 'add_role'}}"
                           class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                <feather type="plus" size="16" class="mr-4"></feather>
                Add role
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="w-full mt-3 md:mt-0 md:mx-4 ">
        <InviteAdministratorsComponent :org-id="orgId"
                                       v-if="path === 'invite_administrators' && organization.im_admin"/>
        <RolesComponent :org-id="orgId" v-else-if="path === 'roles'"/>
        <AddRoleComponent :org-id="orgId" v-else-if="path === 'add_role'"/>
        <RoleComponent :id="id" v-else-if="path === 'role'"/>
        <AdministratorsComponent :org-id="orgId" v-else/>
      </div>
    </div>
  </div>
</template>

<script>
import AdministratorsComponent from "../../components/AdministratorsComponent";
import InviteAdministratorsComponent from "../../components/InviteAdministratorsComponent";
import RolesComponent from "@/modules/organization/RolesComponent";
import AddRoleComponent from "@/modules/organization/AddRoleComponent";
import RoleComponent from "@/modules/organization/RoleComponent";

export default {
  name: "AccessControl",
  components: {
    RoleComponent,
    AddRoleComponent,
    RolesComponent,
    InviteAdministratorsComponent, AdministratorsComponent
  },
  props: {
    orgId: String,
    id: String,
    path: String
  },
  data() {
    return {
      organization: Object
    }
  },
  mounted() {
    this.getOrganization();
  },
  methods: {
    getOrganization() {
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations/' + this.orgId)
          .then((result) => {
            this.organization = result.data.data.organization;
          })
          .catch((error) => {
            this.$root.$emit('error', error);
            this.errors.push("An error occurred while connecting to server")
          }).finally(() => {
      });
    },
    deleteOrganization() {
      if (confirm("Are you sure you want to delete " + this.organization.name + "?."))
        this.axios.delete(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations/' + this.id)
            .then(() => {
              this.$router.push("/organizations");
            })
            .catch((error) => {
              this.$root.$emit('error', error);
              this.errors.push("An error occurred while connecting to server")
            }).finally(() => {
        });
    }
  }
}
</script>

<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
}
</style>